import axios, { AxiosResponse } from 'axios'

import { SettingRead, SettingWrite } from '@generated/types'

const BASE_URL = '/api/settings'

export default {
  async get(): Promise<AxiosResponse<SettingRead>> {
    return axios.get(`${BASE_URL}/`)
  },

  async update(data: SettingWrite): Promise<AxiosResponse<SettingRead>> {
    return axios.put(`${BASE_URL}/`, data)
  },
}
